module.exports = __webpack_public_path__ + "static/img/smfw_tzjsmfw_zydj.0f14646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smfw_tzjsmfw_zydj.png
// module id = bt8v
// module chunks = 21